import { PayableSubjectType } from '../../paymentReconciliationModal/types/payableSubjectType'
import { getReferenceFromSubject } from '../../paymentReconciliationModal/utils'
import { PayableSubject } from '../types'

export const getSubjectReferences = <T extends PayableSubject>(subjects: T[] | T[], type: PayableSubjectType) =>
  subjects.map(({ id }) => ({
    subjectReference: getReferenceFromSubject(id, type),
  }))
